import React from 'react';
import { FormikProps } from 'formik';
import { FormGroup, Input, Label } from 'reactstrap';

import { useTranslation } from 'react-i18next';
import { AdjustPointsFormType } from 'types/customer/customerTypes';

const AdjustPointsForm = ({
  formik,
}: {
  formik: FormikProps<AdjustPointsFormType>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <FormGroup>
        <Label>{t('Account Number')}</Label>
        <Input disabled value={formik.values.accountNumber} />
      </FormGroup>
      <FormGroup>
        <Label>{t('Customer')}</Label>
        <Input disabled value={formik.values.customerName} />
      </FormGroup>

      <FormGroup>
        <Label>{t('History Points')}</Label>
        <Input disabled value={formik.values.historyPoints} />
      </FormGroup>

      <FormGroup>
        <Label>{t('Type')}</Label>
        {/* <div>
          <Label check>
            <Input
              type="radio"
              name="type"
              value="earn"
              checked={formik.values.type === 'earn'}
              onChange={formik.handleChange}
            />
            {t('Top Up Points')}
          </Label>{' '}
          <Label check className="ms-3">
            <Input
              type="radio"
              name="type"
              value="burn"
              checked={formik.values.type === 'burn'}
              onChange={formik.handleChange}
            />
            {t('Deduct Points')}
          </Label>
        </div> */}
        <FormGroup>
          <div className="form-check form-check-inline">
            <Input
              className="form-check-input"
              type="radio"
              name="type"
              id="earn"
              value="earn"
              checked={formik.values.type === 'earn'}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
              }}
            />
            <Label className="form-check-label" htmlFor={'earn'}>
              {t('Top Up Points')}
            </Label>
          </div>

          <div className="form-check form-check-inline">
            <Input
              className="form-check-input"
              type="radio"
              name="type"
              id="burn"
              value="burn"
              checked={formik.values.type === 'burn'}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
              }}
            />
            <Label className="form-check-label" htmlFor={'burn'}>
              {t('Deduct Points')}
            </Label>
          </div>
        </FormGroup>
      </FormGroup>

      <FormGroup>
        <Label>
          {t('Points')} <span className="text-danger">*</span>
        </Label>
        <Input
          type="number"
          name="point"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.point}
          // invalid={!!formik.errors.point && formik.touched.point}
        />
        <div className="text-danger">{formik.errors.point}</div>
      </FormGroup>

      <FormGroup>
        <Label>
          {t('Comments')} <span className="text-danger">*</span>
        </Label>
        <Input
          type="textarea"
          name="comments"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.comments}
          // invalid={!!formik.errors.comments && formik.touched.comments}
        />
        <div className="text-danger">{formik.errors.comments}</div>
      </FormGroup>
    </>
  );
};

export default AdjustPointsForm;
